import { render, staticRenderFns } from "./LicensingTerms.vue?vue&type=template&id=90f62ff4&scoped=true&"
import script from "./LicensingTerms.vue?vue&type=script&lang=js&"
export * from "./LicensingTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f62ff4",
  null
  
)

export default component.exports